import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05b223f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/logo.png",
  alt: "DoctorApp"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Se procesează cererea...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "V-ați dezabonat cu succes.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nu veți mai primi mesaje privind activarea contului de medic în DoctorApp.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Ca medic, vă puteți înscrie în DoctorApp la "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://register.doctorapp.ro/request-account" }, "https://register.doctorapp.ro/request-account"),
  /*#__PURE__*/_createTextVNode(" sau ne puteți contacta la "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:sanatate@doctorapp.ro" }, "sanatate@doctorapp.ro"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AppContext } from '@/config/AppContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestAccountUnsubscribeView',
  setup(__props) {

const route = useRoute();
const loading = ref(true);

onMounted(async () => {
  const p = route.query.p as string;
  const sig = route.query.sig as string;
  try {
    const url = AppContext.getApiUrlPath()
      + '/register-requests/reminder/opt-out'
      + '?p=' + encodeURIComponent(p)
      + '&sig=' + encodeURIComponent(sig);
    await fetch(url, { method: 'GET' });
  } catch (e) {
    // Always show success regardless
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
    ])
  ]))
}
}

})